import { render, staticRenderFns } from "./SharedResortsList.vue?vue&type=template&id=d39d8dda&"
import script from "./SharedResortsList.vue?vue&type=script&lang=js&"
export * from "./SharedResortsList.vue?vue&type=script&lang=js&"
import style0 from "./SharedResortsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports